import { render, staticRenderFns } from "./MentorAddEdit.vue?vue&type=template&id=da17e832&scoped=true"
import script from "./MentorAddEdit.vue?vue&type=script&lang=js"
export * from "./MentorAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da17e832",
  null
  
)

export default component.exports